import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { OdinSettingsPageComponent } from './odin-settings-page/odin-settings-page.component';
import { ReceiptConfigurationPageComponent } from './receipt-configuration-page/receipt-configuration-page.component';
import { SettingsHomePageComponent } from './settings-home-page/settings-home-page.component';

// Note: 'settings/integrations' is served by the lazily loaded OdinIntegrationsModule (see app routing).
export const routes: Routes = [
  { path: '', component: SettingsHomePageComponent, pathMatch: 'full' },
  { path: 'theme', component: OdinSettingsPageComponent },
  { path: 'receipts', component: ReceiptConfigurationPageComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class OdinSettingsRoutingModule {}
